import _ from 'lodash';
import { createContext, useContext, useReducer } from 'react';

const OrganizationContext = createContext(null);

const OrganizationDispatchContext = createContext(null);

export function OrganizationProvider({ children }) {
  const [selection, dispatch] = useReducer(selectionReducer, initialState);

  return (
    <OrganizationContext.Provider value={selection}>
      <OrganizationDispatchContext.Provider value={dispatch}>{children}</OrganizationDispatchContext.Provider>
    </OrganizationContext.Provider>
  );
}

export function useOrganizations() {
  return useContext(OrganizationContext);
}

export function useOrganizationsDispatch() {
  return useContext(OrganizationDispatchContext);
}

function selectionReducer(state, action) {
  // console.log('organization-context.selectionReducer(): state = %o, action = %o', state, action);
  let newState = _.cloneDeep(state);
  switch (action.type) {
    case 'organization-selected': {
      newState.organizationIds = [action.organizationId];
      break;
    }
    case 'organization-toggled': {
      newState.organizationIds = _.xor(newState.organizationIds, [action.organizationId]);
      break;
    }
    case 'organization-selection-cleared': {
      newState.organizationIds = [];
      break;
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
  return newState;
}

const initialState = { organizationIds: [] };
